(function(){
  const WIDGET_SELECTOR = '.delivery-services';

  async function fetchCityByPincode(pincode){
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await res.json();
      // API shape: [ { PostOffice: [ { State, District, ... } ] } ]
      const postOffice = Array.isArray(data) && data[0] && Array.isArray(data[0].PostOffice)
        ? data[0].PostOffice[0]
        : null;
      return {
        city: (postOffice && (postOffice.District || postOffice.Block)) || '',
        state: (postOffice && postOffice.State) || ''
      };
    } catch(e){
      return { city: '', state: '' };
    }
  }

  async function fetchDeliveryDate(originPin, destPin){
    try{
      const expected_pickup_date = new Date();
      expected_pickup_date.setDate(expected_pickup_date.getDate() + 1);
      const pickup = `${expected_pickup_date.toISOString().split('T')[0]} 10:00`;
      const params = new URLSearchParams({ origin_pin: originPin, destination_pin: destPin, mot: 'S', pdt: 'B2C', expected_pickup_date: pickup });
      const res = await fetch(`https://delhivery-server-proxy-umber.vercel.app/api/tat?${params.toString()}`, { headers: { 'Authorization': 'Token 6295351002af6cc182491e28b9ab6cb131c4a6a8' }});
      const json = await res.json();
      if(json?.success && json?.data?.expected_delivery_date){
        const raw = json.data.expected_delivery_date;
        const d = new Date(raw);
        const formatted = d.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' });
        return { ok: true, date: formatted, raw };
      }
      return { ok: false };
    }catch(e){
      return { ok: false };
    }
  }

  function init(root){
    const input = root.querySelector('.delivery-services__pincode');
    const btn = root.querySelector('.delivery-services__check');
    const cityEl = root.querySelector('.delivery-services__city');
    const locationRow = root.querySelector('.delivery-services__location');
    const card = root.querySelector('.delivery-services__card--success');
    const dateEl = root.querySelector('.delivery-services__date');
    const errorEl = root.querySelector('.delivery-services__error');
    const codCard = root.querySelector('.delivery-services__card--info');
    const codText = root.querySelector('.delivery-services__cod-text');
    const originPin = root.dataset.originPin || '144001';
    const returnsCard = root.querySelector('.delivery-services__card--returns');
    const installationCard = root.querySelector('.delivery-services__card--installation');
    const installationDateEl = root.querySelector('.delivery-services__installation-date');

    function handleError(msg){
      errorEl.textContent = msg;
      errorEl.classList.remove('hidden');
    }

    const btnSpinner = btn.querySelector('.loading-overlay__spinner');
    const btnLabel = btn.querySelector('.delivery-services__check-label');

    btn.addEventListener('click', async () => {
      if(btn.classList.contains('loading')) return;
      // match theme buttons: add .loading and unhide spinner
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', true);
      if (btnSpinner) btnSpinner.classList.remove('hidden');
      if (btnLabel) btnLabel.classList.add('hidden');
      try {
        errorEl.classList.add('hidden');
        card.classList.add('hidden');
        locationRow.classList.add('hidden');
        // Hide COD card while fetching so it doesn't flash old content
        codCard.classList.add('hidden');
        if (returnsCard) returnsCard.classList.add('hidden');
        if (installationCard) installationCard.classList.add('hidden');
        codText.textContent = '';

        const pin = (input.value || '').trim();
        if(!/^\d{6}$/.test(pin)) {
          handleError('Please enter a valid 6-digit pincode');
          return;
        }

        const [place, delivery] = await Promise.all([
          fetchCityByPincode(pin),
          fetchDeliveryDate(originPin, pin)
        ]);

        if(place.city){
          cityEl.textContent = place.city;
          locationRow.classList.remove('hidden');
        }

        if(delivery.ok){
          dateEl.textContent = delivery.date;
          card.classList.remove('hidden');
        } else {
          handleError('Could not calculate delivery date. Please try again later.');
        }

        // COD availability based on state list
        const blocked = new Set([
          'Andaman & Nicobar',
          'Assam',
          'Dadra & Nagar Haveli',
          'Daman and Diu',
          'Jammu & Kashmir',
          'Ladakh',
          'Lakshadweep',
          'Manipur',
          'Meghalaya',
          'Mizoram',
          'Nagaland',
          'Sikkim',
          'Tripura'
        ]);
        const state = (place.state || '').trim();
        const codAvailable = state && !blocked.has(state);
        codText.textContent = codAvailable ? 'Pay on delivery Available on Checkout' : 'Pay on delivery Not available';
        codText.style.color = codAvailable ? '#2e7d32' : '#d32f2f';
        codCard.classList.remove('hidden');
        if (returnsCard) returnsCard.classList.remove('hidden');

        // Installation: show only if product belongs to 'fitness' collection
        try {
          const collections = (window.productCollections || []);
          const hasFitness = collections.some(c => (c && (c.handle === 'fitness' || c.title?.toLowerCase() === 'fitness')));
          if (hasFitness && installationCard) {
            if (delivery.ok && delivery.raw && installationDateEl) {
              const base = new Date(delivery.raw);

              // Start = +1 day, End = +3 days
              const start = new Date(base);
              start.setDate(base.getDate() + 1);

              const end = new Date(base);
              end.setDate(base.getDate() + 3);

              const fmt = d => d.toLocaleDateString('en-IN', {
                weekday: 'long',
                day: 'numeric',
                month: 'long'
              });

              // Show range of dates
              installationDateEl.textContent = `${fmt(start)} – ${fmt(end)}`;
            }

            installationCard.classList.remove('hidden');
          }
        } catch(e) { /* no-op */ }
      } finally {
        btn.setAttribute('aria-disabled', false);
        btn.classList.remove('loading');
        if (btnSpinner) btnSpinner.classList.add('hidden');
        if (btnLabel) btnLabel.classList.remove('hidden');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(WIDGET_SELECTOR).forEach(init);
  });
})();
